import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import db from '../data/db';
import { FiArrowLeft, FiCheck } from 'react-icons/fi';

const EMOJIS = ['📖', '📚', '🧬', '💻', '🌍', '💊', '🎵', '🔬', '📐', '🎨', '🧠', '⚡', '🔥', '📝', '🎯', '🌿'];

export default function DeckForm() {
  const { deckId } = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [emoji, setEmoji] = useState('📖');
  const isEditing = !!deckId;

  useEffect(() => {
    if (deckId) {
      db.decks.get(Number(deckId)).then(deck => {
        if (deck) {
          setName(deck.name);
          setDescription(deck.description || '');
          setEmoji(deck.emoji || '📖');
        }
      });
    }
  }, [deckId]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim()) return;

    if (isEditing) {
      await db.decks.update(Number(deckId), { name, description, emoji });
      navigate(`/deck/${deckId}`);
    } else {
      const id = await db.decks.add({
        name,
        description,
        emoji,
        createdAt: new Date().toISOString(),
        cardCount: 0,
      });
      navigate(`/deck/${id}/add`);
    }
  }

  return (
    <div className="page">
      <button className="btn btn-ghost back-btn" onClick={() => navigate(isEditing ? `/deck/${deckId}` : '/')}>
        <FiArrowLeft /> Back
      </button>

      <h1>{isEditing ? 'Edit Deck' : 'Create New Deck'}</h1>

      <form className="deck-form" onSubmit={handleSubmit}>
        <div className="form-field">
          <label>Emoji</label>
          <div className="emoji-picker">
            {EMOJIS.map(e => (
              <button
                key={e}
                type="button"
                className={`emoji-option ${emoji === e ? 'selected' : ''}`}
                onClick={() => setEmoji(e)}
              >
                {e}
              </button>
            ))}
          </div>
        </div>

        <div className="form-field">
          <label htmlFor="deck-name">Deck Name</label>
          <input
            id="deck-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., Organic Chemistry, Spanish Vocabulary"
            autoFocus
          />
        </div>

        <div className="form-field">
          <label htmlFor="deck-desc">Description (optional)</label>
          <textarea
            id="deck-desc"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="What will you learn in this deck?"
            rows={3}
          />
        </div>

        <button className="btn btn-primary btn-lg" type="submit" disabled={!name.trim()}>
          <FiCheck /> {isEditing ? 'Save Changes' : 'Create Deck'}
        </button>

        {!isEditing && (
          <p className="deck-form-ai-hint">
            Or <button type="button" className="btn-link" onClick={() => navigate('/decks/generate')}>paste your notes and let AI build the deck →</button>
          </p>
        )}
      </form>
    </div>
  );
}
